var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"set-target-wrap"},[_c('div',[_c('label',[_vm._v("Amount")]),_c('currency-field',{on:{"input":function($event){return _vm.$emit('change:target-amount', $event)}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }